/**
 * @file 公共指令
 */

// 点击后自动失焦
// 用法   <a-button v-blurOnClick>Click me</a-button>
const blurOnClick = {
  inserted(el) {
    el.addEventListener('click', () => {
      el.blur();
    });
  },
};

const defaults = {
  blurOnClick,
};
export default defaults;
